module.exports = __webpack_public_path__ + "static/media/aztec-gems.fa9b8538.gif";